import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";

export default function TextEditDialog({
  title,
  placeholder = "",
  isOpen,
  onCancel,
  onSubmit,
}: {
  placeholder: string;
  title: string;
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: (newName: string) => void;
}) {
  const [name, setName] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (placeholder && isOpen) {
      setName(placeholder);
    }
  }, [isOpen]);

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" || event.key === "Escape") {
      onSubmit(name);
    }
  };
  return (
    <>
      <Transition
        appear
        show={isOpen}
        as={Fragment}
        afterEnter={() => inputRef.current?.focus()}
      >
        <Dialog as="div" className="relative z-10" onClose={() => onCancel()}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 lg:left-56 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-xl transform rounded-lg bg-white py-4 lg:py-6 px-4 lg:px-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between items-center">
                    <div className="text-xl font-semibold leading-6 text-slate-700 flex items-center">
                      <span>{title}</span>
                    </div>
                  </div>
                  <div className="mt-5 space-y-6">
                    <input
                      autoFocus
                      ref={inputRef}
                      onKeyDown={onKeyDown}
                      id="name"
                      name="name"
                      type="text"
                      autoComplete="name"
                      required
                      className="w-full px-3 py-2 border disabled:bg-slate-200 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 focus:z-10 sm:text-sm"
                      placeholder=""
                      onChange={(targetEvent) =>
                        setName(targetEvent.target.value)
                      }
                      value={name}
                    />
                  </div>
                  <div className="mt-4 flex justify-end space-x-4">
                    <button
                      className=" rounded px-4 p-2 hover:bg-slate-200 font-semibold text-slate-600"
                      onClick={onCancel}
                    >
                      Cancel
                    </button>
                    <button
                      className="bg-red-600 text-white rounded px-4 p-2 hover:bg-red-800 font-semibold"
                      onClick={() => onSubmit(name)}
                    >
                      OK
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
